import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import clsx from 'clsx';
import { Chip, makeStyles } from '@material-ui/core';
import { useTranslate } from 'react-admin';

const status = {
  REJECTED: 'rejected',
  PENDING: 'pending',
  APPROVED: 'approved',
};

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 90,
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      fontSize: 12,
    },
    approved: {
      backgroundColor: theme.palette.status.success,
    },
    pending: {
      backgroundColor: theme.palette.status.pending,
    },
    rejected: {
      backgroundColor: theme.palette.status.fail,
    },
  };
});

const CleanerDocumentStatusChipField = ({ record, source }) => {
  const value = get(record, source);

  const translate = useTranslate();
  const classes = useStyles();

  return (
    <Chip
      className={clsx(classes.root, classes[status[value]])}
      color="primary"
      label={translate(
        `components.field.cleaner_document.${value}`,
      ).toUpperCase()}
      size="small"
    />
  );
};

CleanerDocumentStatusChipField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

CleanerDocumentStatusChipField.defaultProps = {
  record: {},
};

export default CleanerDocumentStatusChipField;
